<template>
    <div class="home-page__outer">
        <div class="home-page__element">
            <b-row no-gutters>
                <b-col lg="12">
                    <img class="logo" src="../../../assets/img/futuronetwork-logo--white.png" alt="FuturoNetwork">
                </b-col>
            </b-row>
        </div>
        <div class="home-page__element">
            <b-row no-gutters>
                <b-col lg="12">
                    <h1 class="title">
                        Welcome to FuturoNetwork <br class="desktop-only">online business
                    </h1>
                </b-col>
            </b-row>
            <form @submit.prevent="validate">
                <b-row class="register-form">
                    <b-col lg="12">
                        <div class="form-item form-input"
                             :class="{ 'form-item--error': (errors.has('username') && showErrors) || invalidData }">
                            <input type="text"
                                   placeholder="login"
                                   name="username"
                                   id="field_username"
                                   v-model="username"
                                   v-validate
                                   data-vv-rules="required"
                                   :readonly="view == 1">
                            <p class="field-error--description field-error--description--white"
                               v-show="errors.has('username') && showErrors">{{ errors.first('username') }}</p>
                        </div>
                        <div class="form-item form-input"
                             :class="{ 'form-item--error': (errors.has('username') && showErrors) || invalidData }">
                            <input type="password"
                                   placeholder="password"
                                   name="password"
                                   id="field_password"
                                   v-model="password"
                                   v-validate
                                   data-vv-rules="required"
                                   :readonly="view == 1">
                            <p class="field-error--description field-error--description--white"
                               v-show="errors.has('password') && showErrors">{{ errors.first('password') }}</p>
                        </div>
                        <p class="form-item--error--description form-item--error--description--white"
                           v-show="invalidData" style="color: red">Invalid data.</p>
                        <p class="form-item--error--description form-item--error--description--white"
                           v-show="invalidCaptcha" style="color: red">Captcha field is required.</p>
                        <vue-recaptcha
                                class="g-recaptcha"
                                @verify="onVerify"
                                @render="onRender"
                                :sitekey="recaptcha.sitekey">
                        </vue-recaptcha>
                        <div class="buttons">
                            <button class="button--primary login"
                                    :class="{ 'button--progress': progress }"
                                    :style="{'width': '100%'}"
                                    :type="progress ? 'button' : 'submit'">Login</button>
                        </div>
                        <p class="form-link"
                           @click="changeView(3)">Forgot your password?</p>
                        <div class="to-register">
                            Don't you have an account?<br><a style="cursor: pointer"
                                                             @click="goToRegister()">Register now!</a>
                        </div>
                    </b-col>
                </b-row>
            </form>
        </div>
        <div class="home-page__element"></div>
    </div>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        dependencies: ['api', 'status', 'user', 'recaptcha'],
        components: { VueRecaptcha },
        props: ['saveCaptcha', 'view'],
        data() {
            return {
                invalidData: false,
                invalidCaptcha: false,
                password: '',
                progress: false,
                showErrors: false,
                username: '',
            }
        },

        methods: {
            onVerify: function (response) {
                this.recaptcha.SetRecaptchaResponse(response);
            },
            onRender: function(recaptchaId) {
                this.recaptchaId = recaptchaId;
            },
            changeView (view) {
                this.$store.commit('loginFormView', 6);
                setTimeout(() => {
                    this.$store.commit('loginFormView', view);
                }, 600);
            },
            goToRegister () {
                this.$store.commit('loginFormView', 6);
                setTimeout(() => {
                    this.$router.push({ name: 'Register' });
                }, 600);
            },
            loginSuccess(data) {
                this.progress = false;
                this.user.fetchData(data);
                this.$router.push({ name: 'Dashboard' });
            },
            validate() {
                this.showErrors = false;
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submit();
                    } else {
                        this.showErrors = true;
                    }
                })
            },
            submit() {
                let vm = this;
                vm.invalidData = false;
                vm.invalidCaptcha = false;
                vm.progress = true;
                vm.saveCaptcha(this.recaptcha.GetRecaptchaResponse());
                vm.$http.post(this.api.auth.login, {
                    _username: vm.username,
                    _password: vm.password,
                    'g-recaptcha-response': this.recaptcha.GetRecaptchaResponse()
                })
                    .then(response => {
                        vm.loginSuccess(response.data);
                        this.recaptcha.SetRecaptchaResponse(null);
                    }, error => {
                        this.$children.find(( component ) => {
                            return component.$widgetId === this.recaptchaId;
                        }).reset();
                        setTimeout(() => {
                            vm.progress = false;
                            switch (error.status){
                                case (400):
                                    vm.invalidData = true;
                                    this.recaptcha.SetRecaptchaResponse(null);
                                    break;
                                case (422):
                                    if (error.data &&
                                        error.data.errors &&
                                        error.data.errors[0].message === 'This value is not a valid captcha.'){
                                        vm.invalidCaptcha = true;
                                    } else {
                                        vm.progress = true;
                                        vm.$http.post(this.api.auth.login, {
                                            _username: vm.username,
                                            _password: vm.password,
                                            token: 'GENERATE'
                                        }).then(response => {
                                            vm.loginSuccess(response.data);
                                            this.recaptcha.SetRecaptchaResponse(null);
                                        }, error => {
                                            vm.progress = false;
                                            switch (error.status){
                                                case (400):
                                                    vm.invalidData = true;
                                                    break;
                                                case (422):
                                                    this.changeView(1);
                                                    break;
                                                default:
                                                    error.status ? this.status['status' + error.status]() : '';
                                            }
                                        });
                                    }
                                    break;
                                default:
                                    error.status ? this.status['status' + error.status]() : '';
                            }
                        }, 1000);
                    });
            }
        },
        beforeCreate () {
            this.$store.commit('loginFormView', 2);
        },
        mounted () {
            this.changeView(0);
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_colors.scss';
    @import '../../../assets/scss/_guest.scss';

    .form-link{
        margin-top: 15px;
        color: $base1;
        font-weight: 100;
        cursor: pointer;
        text-align: right;

        &:hover,
        &:focus{
            text-decoration: underline;
        }

         @media(max-width: 991px){
             color: $white;
             font-size: 26px;
         }
    }

    .to-register{
        margin: 30px auto;
        color: $white;
        text-align: center;

        a{
            color: white;

            &:hover,
            &:focus{
                 text-decoration: underline;
            }
        }
    }

    .logo{
        margin: 30px 0;

        @media(max-width: 767px){
            display: block;
            margin: 30px auto;
        }
    }

    .title{
        color: $white;
        font-weight: bold;
        font-size: 34px;
        line-height: 1.2;

        @media(max-width: 767px){
            text-align: center;
        }
    }

    .g-recaptcha {
        transform:scale(0.894);
        transform-origin:0 0;
    }

    button{
        line-height: 39px;
    }
</style>



// WEBPACK FOOTER //
// src/components/login/partials/LoginForm.vue